import axios from "axios";

const apiUri = import.meta.env.GATEWAY_URI;

export default function useSoundCloud() {
  const searchTracks = async (search) => {
    const result = await axios.get(
      `${apiUri}/api/v1/soundcloud/tracks?name=${search ?? ""}`
    );

    return result.data.data;
  };

  return {
    searchTracks,
  };
}
